/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import _ from 'lodash'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSystemSettings } from '../../../vendor/react-omnitech-api'
import Link from '../../link'
import WithAuth from '../../withAuth'

import useStyles from './dropdown-menu-style'
import combineClassNames from '../../../helpers/combineClassNames'
import { useThemeConfig } from '../../../hook/use-theme-config'

const DropdownMenuView = ({
  stylesDropdown,
  onCouponMarketplaceOpen,
  onMemberCodeOpen,
  qrCode,
}) => {
  const styles = useStyles()
  const { t } = useTranslation()
  const { getSystemSetting } = useSystemSettings()
  const { getConfig } = useThemeConfig()

  const favouritesEnabled = !getSystemSetting('hide_favourites', false)
  const storeCreditEnabled = getSystemSetting('payment_gateway.enable_stored_value', false)
  const defaultMenuConfig = [
    {
      id: 'account',
      path: '/account/',
    },
    {
      id: 'orders',
      path: '/account/orders/',
    },
    {
      id: 'coupons',
    },
    // {
    //   id: 'rewards',
    //   path: '/account/my-coupons/',
    // },
    {
      id: 'member',
    },
    {
      id: 'storeCredit',
      path: '/account/store-credit/',
    },
    {
      id: 'favourites',
      path: '/account/favourites/',
    },
  ]
  const menuConfig = _.filter(
    getConfig('config.ui.headerAccountMenu', defaultMenuConfig),
    ({ id }) => {
      if (id === 'favourites') {
        return favouritesEnabled
      }
      if (id === 'member') {
        return !_.isEmpty(qrCode)
      }
      if (id === 'storeCredit') {
        return storeCreditEnabled
      }
      return true
    },
  )
  return (
    <div
      className={stylesDropdown}
    >
      <WithAuth
        isAuth={() => (
          <ul>
            {
              _.map(menuConfig, (item) => {
                const { id, path } = item
                switch (id) {
                  case 'member':
                    return (
                      <li
                        key={`dropdown_menu_${id}`}
                        className={combineClassNames([styles.listItem])}
                        onClick={onMemberCodeOpen}
                      >
                        <span
                          className={combineClassNames([styles.listItemInner])}
                        >
                          {t('ui.header.member')}
                        </span>
                      </li>
                    )
                  case 'coupons':
                    return (
                      <li
                        key={`dropdown_menu_${id}`}
                        className={combineClassNames([styles.listItem])}
                        onClick={onCouponMarketplaceOpen}
                        onKeyDown={onCouponMarketplaceOpen}
                      >
                        <span
                          className={combineClassNames([styles.listItemInner])}
                        >
                          {t('ui.header.coupons')}
                        </span>
                      </li>
                    )
                  default:
                    return (
                      <li
                        key={`dropdown_menu_${id}`}
                        className={combineClassNames([styles.listItem])}
                      >
                        <Link
                          gatsbyLink
                          to={path}
                          className={styles.listItemInner}
                        >
                          {t(`ui.header.${id}`)}
                        </Link>
                      </li>
                    )
                }
              })
            }
            <li className={styles.listItem}>
              <Link
                gatsbyLink
                to="/logout/"
                className={styles.listItemInner}
              >
                {t('ui.header.logout')}
              </Link>
            </li>
          </ul>
        )}
        isNotAuth={() => (
          <ul>
            <li className={combineClassNames([styles.listItem, styles.login])}>
              <Link
                gatsbyLink
                to="/login/"
                className={styles.listItemInner}
              >
                {t('ui.header.login')}
              </Link>
            </li>
            <li className={combineClassNames([styles.listItem, styles.register])}>
              <Link
                gatsbyLink
                to="/registration/"
                className={styles.listItemInner}
              >
                {t('ui.header.register')}
              </Link>
            </li>
          </ul>
        )}
      />
    </div>
  )
}

export default DropdownMenuView
